import type {IFornecedor} from "@models/fornecedores/fornecedor.js";
import React from "react";
import {DefaultConsumerPesquisaAutoProps, DefaultPesquisaAuto} from "@shared/specialComponents/DefaultPesquisaAuto.tsx";
import _fornecedor_endpoints from "@components/fornecedores/endpoints/_fornecedor_endpoints.ts";
import {useFornecedor} from "@components/fornecedores/hooks/useFornecedor.ts";

interface FornecedorPesquisaProps extends DefaultConsumerPesquisaAutoProps<IFornecedor, { search: string }> {
}

export function FornecedorPesquisa(props: FornecedorPesquisaProps) {
    const {useFornecedorValue} = useFornecedor()
    const formatar = (fornecedor: IFornecedor) => `${fornecedor.idErp} - ${fornecedor.nome}  ${fornecedor.cpfCnpj}`;
    const [initialValue] = useFornecedorValue(props.options?.initialValue)

    return (
        <DefaultPesquisaAuto<IFornecedor, { search: string }>
            itemToString={formatar}
            display={{name: 'Fornecedor'}}
            options={{initialValue}}
            endpoint={(x) => {
                return _fornecedor_endpoints.getFornecedoresPesquisa(x.data.search, x.pagination)
            }}
            searchField={'search'}
            {...props}
        />
    )
}
